import { GoogleAPI } from 'google-maps-react';
import { UserModel } from '../api/authentication/authentication.types';
import { History } from 'history';
import { WithTranslation } from 'react-i18next';
import { SupplierModel } from '../api/admin/admin.types';

export interface AppProps extends WithTranslation {
  storeActiveSupplier: (supplier: SupplierModel) => void;
  storeDeskGroupId: (id: number) => void;
  storeAcrissCodes: (codes: string[]) => void;
  storeProductId: (id: number) => void;
  history: History;
  user: UserModel | null;
}

export const LOCALSTORAGE_USER_FIELD = 'user';
export const LOCALSTORAGE_TOKEN_FIELD = 'token';
export const LOCALSTORAGE_SUPPLIERS = 'suppliers';
export const LOCALSTORAGE_ACTIVE_SUPPLIER = 'activeSupplier';
export const STORED_PRODUCT_ID = 'storedProductId';
export const STORED_DESK_GROUP_ID = 'storedDeskGroupId';
export const STORED_ACRISS_CODES = 'storedAcrissCodes';
export const LOCALSTORAGE_RATES_REQUEST_TEST_FILTERS = 'ratesRequestTestFilters';

export interface ApisAvailable {
  frontendServerApi: string;
}

export interface AppConfig {
  applicationId: string;
  googleApiKey: GoogleAPI;
  apiUrls: ApisAvailable;
  gaMeasurementId: string;
  hotJarSiteId: string;
  hotJarSiteVersion: string;
}
